<a *ngIf="(exist && published) || authentication.user.role >= 100" href="javascript:void(0)" (click)="clicked()">
  <span class="fa fa-question-circle-o"></span>
</a>
